import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { paths, ROOTS } from '@/shared/config/paths';
import { withSuspense } from '../utils';
import type { TypedRouteObject } from '../types';

const Operation = lazy(() => import('@/pages/operation'));
const CaptionList = lazy(() => import('@/pages/operation/caption/CaptionList'));
const NewsList = lazy(() => import('@/pages/operation/news/NewsList'));
const NewsDetail = lazy(() => import('@/pages/operation/news/NewsDetail'));
const InstagramList = lazy(() => import('@pages/operation/instagram/InstagramList'));
const InstagramDetail = lazy(() => import('@pages/operation/instagram/InstagramDetail'));
const YoutubeList = lazy(() => import('@pages/operation/youtube/YoutubeList'));
const YoutubeDetail = lazy(() => import('@pages/operation/youtube/YoutubeDetail'));
const PrivacyPolicyList = lazy(() => import('@pages/operation/privacyPolicy/PrivacyPolicyList'));
const PrivacyPolicyDetail = lazy(() => import('@pages/operation/privacyPolicy/PrivacyPolicyDetail'));
const TermsOfServiceList = lazy(() => import('@pages/operation/termsOfService/TermsOfServiceList'));
const TermsOfServiceDetail = lazy(() => import('@pages/operation/termsOfService/TermsOfServiceDetail'));

export const operationRoutes: TypedRouteObject = {
	path: ROOTS.OPERATION,
	element: withSuspense(Operation),
	handle: {
		title: '운영',
		subTitle: '락앤런 운영 관리'
	},
	children: [
		{
			index: true,
			element: <Navigate to="list" replace />
		},
		// 자막 관리
		{
			path: paths.operation.caption.list.path,
			element: withSuspense(CaptionList),
			handle: {
				title: '고객향 자막 관리',
				subTitle: '락앤런 고객향 상단 자막 관리'
			}
		},
		
		// 뉴스 관리
		{
			path: paths.operation.news.list.path,
			element: withSuspense(NewsList),
			handle: {
				title: '뉴스 관리',
				subTitle: '고객향 장수 뉴스 관리'
			}
		},
		{
			path: paths.operation.news.detail.path,
			element: withSuspense(NewsDetail),
			handle: {
				isGoBack: true,
				title: '뉴스 관리',
				subTitle: '운영 > 뉴스 관리 > 뉴스 상세정보'
			}
		},
		// 인스타그램 관리
		{
			path: paths.operation.instagram.list.path,
			element: withSuspense(InstagramList),
			handle: {
				title: '인스타그램 링크 관리',
				subTitle: '고객향 인스타그램 소식 관리'
			}
		},
		{
			path: paths.operation.instagram.detail.path,
			element: withSuspense(InstagramDetail),
			handle: {
				isGoBack: true,
				title: '인스타그램 상세정보',
				subTitle: '운영 > 인스타그램 > 상세정보'
			}
		},
		// 유튜브 관리
		{
			path: paths.operation.youtube.list.path,
			element: withSuspense(YoutubeList),
			handle: {
				title: '유튜브 링크 관리',
				subTitle: '고객향 메인 유튜브 링크 관리'
			}
		},
		{
			path: paths.operation.youtube.detail.path,
			element: withSuspense(YoutubeDetail),
			handle: {
				isGoBack: true,
				title: '유튜브 상세정보',
				subTitle: '운영 > 유튜브 > 상세정보'
			}
		},
		// 개인정보 처리방침
		{
			path: paths.operation.privacyPolicy.list.path,
			element: withSuspense(PrivacyPolicyList),
			handle: {
				title: '개인정보 처리방침',
				subTitle: '락앤런 개인정보 처리방침'
			}
		},
		{
			path: paths.operation.privacyPolicy.detail.path,
			element: withSuspense(PrivacyPolicyDetail),
			handle: {
				isGoBack: true,
				title: '개인정보 처리방침 상세정보',
				subTitle: '운영 > 개인정보 처리방침 > 상세정보'
			}
		},
		// 이용약관
		{
			path: paths.operation.termsOfService.list.path,
			element: withSuspense(TermsOfServiceList),
			handle: {
				title: '이용약관',
				subTitle: '락앤런 가입자 이용약관'
			}
		},
		{
			path: paths.operation.termsOfService.detail.path,
			element: withSuspense(TermsOfServiceDetail),
			handle: {
				isGoBack: true,
				title: '이용약관 상세정보',
				subTitle: '운영 > 가입자 이용약관 > 상세정보'
			}
		},
	]
}
